import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad,
  Route,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.checkAuth(state.url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.checkAuth(state.url);
  }

  canLoad(route: Route): Promise<boolean | UrlTree> {
    return this.checkAuth(route.path || '/');
  }

  private async checkAuth(requestedUrl?: string): Promise<boolean | UrlTree> {
    if (this.authService.hasValidCookieSession()) {
      return true;
    }

    await this.authService.waitForAuthReady();
    if (await this.authService.syncSessionFromFirebase()) {
      return true;
    }

    return this.router.createUrlTree(['/auth/login'], {
      queryParams: { returnUrl: requestedUrl || '/' },
    });
  }
}
